import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { EMOTION_ORDER } from './resultsMockData'

/** Horizontal swatch + label legend for the 7 emotion series. */
export default function EmotionLegend() {
  const theme = useTheme()
  const c = theme.affexy.colors
  const { t } = useTranslation('results')

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, pt: 0.5 }}>
      {EMOTION_ORDER.map((k) => (
        <Box
          key={k}
          component="span"
          sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, fontSize: 12, color: c.ink72 }}
        >
          <Box component="span" sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: theme.affexy.emotion[k] }} />
          {t(`emotion.${k}`)}
        </Box>
      ))}
    </Box>
  )
}
